import { render, staticRenderFns } from "./wap2024.vue?vue&type=template&id=7ac30df8&scoped=true"
import script from "./wap2024.vue?vue&type=script&lang=js"
export * from "./wap2024.vue?vue&type=script&lang=js"
import style0 from "./wap2024.vue?vue&type=style&index=0&id=7ac30df8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac30df8",
  null
  
)

export default component.exports